import { Box, SxProps, Theme } from '@mui/material';

const mcpIconUrl = 'https://cdn.jsdelivr.net/gh/lobehub/lobe-icons@master/packages/static-svg/icons/mcp.svg?currentColor=true';

interface McpIconProps {
	size?: number;
	sx?: SxProps<Theme>;
}

export default function McpIcon({ size = 18, sx }: McpIconProps) {
	const baseSx = {
		width: size,
		height: size,
		display: 'inline-block',
		boxSizing: 'content-box',
		bgcolor: 'currentColor',
		pl: '2px',
		maskImage: `url("${mcpIconUrl}")`,
		maskPosition: 'right center',
		maskRepeat: 'no-repeat',
		maskSize: 'contain',
		WebkitMaskImage: `url("${mcpIconUrl}")`,
		WebkitMaskPosition: 'right center',
		WebkitMaskRepeat: 'no-repeat',
		WebkitMaskSize: 'contain',
	};

	return <Box component="span" role="img" aria-label="MCP" sx={Array.isArray(sx) ? [baseSx, ...sx] : [baseSx, sx]} />;
}
